import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileUploadHandlerEvent, FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import {
  CAD_UPLOAD_ACCEPT,
  CAD_UPLOAD_EXTENSIONS_LABEL,
} from '../../../models/cad-file.model';

@Component({
  selector: 'app-upload-cad',
  imports: [FileUploadModule, ButtonModule, Tooltip],
  templateUrl: './upload-cad.component.html',
  styleUrl: './upload-cad.component.scss',
})
export class UploadCadComponent {
  @Input() multiple = false;
  /** MIME / extension accept string for p-fileupload (defaults to CAD formats). */
  @Input() accept = CAD_UPLOAD_ACCEPT;
  /** Shown under the dropzone as "Supported formats: …". */
  @Input() extensionsLabel = CAD_UPLOAD_EXTENSIONS_LABEL;

  @Output() filesSelected = new EventEmitter<File[]>();

  isDraggingOver = false;

  onUpload(event: FileUploadHandlerEvent): void {
    this.filesSelected.emit(event.files ?? []);
  }

  removeFile(files: File[], index: number): void {
    files.splice(index, 1);
  }

  onDragOver(event?: DragEvent): void {
    event?.preventDefault();
    this.isDraggingOver = true;
  }

  onDragLeave(event?: DragEvent): void {
    event?.preventDefault();
    this.isDraggingOver = false;
  }

  onDrop(event?: DragEvent): void {
    event?.preventDefault();
    this.isDraggingOver = false;
  }
}
